import s from './index.module.scss'
import {FC} from "react";

type Props = {
  data: {
    title: string
    list: {
      name: string
      position?: string
      text: string
    }[]
  }
}

const Testimonials:FC<Props> = ({data}) => {
  return (
    <div className={s.root}>
      <h2 className={s.title}>{data.title || 'Testimonials'}</h2>
      {data?.list[0] ? (
      <div className={s.list}>
        {data?.list.map((item, index) => (
          <div key={index} className={index % 2 === 0 ? s.item :  s.itemRight}>
            <div className={s.text}>{item.text}</div>
            <div className={s.name}>
              {item.name}
              {item.position ? <div className={s.position}>{item.position}</div> : null}
            </div>
          </div>
        ))}
      </div>
          ) : null}
    </div>
  )
}

export default Testimonials
